import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9f0b84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-l" }, null, -1))
const _hoisted_2 = {
  class: "text-xs pageBottom",
  "data-cy": "pdf-page-bottom",
  style: {"margin-bottom":"2.5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, " Erstellt am " + _toDisplayString(new Date().toLocaleDateString('de-DE')) + " mit der MoversSurvey - APP ", 1)
  ], 64))
}